
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","stroke":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.003 24.549h-6.002M17 24.549H9.997M26.003 18H18M14.999 18H9.997M26.003 11.451h-4.001M19 11.451H9.997M20 27.004v-4.91M14.999 20.455v-4.91M22.002 13.906v-4.91","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    